// Generated by ReScript, PLEASE EDIT WITH CARE
/* @generated */
'use strict';

let RescriptRelay = require("rescript-relay/src/RescriptRelay.bs.js");
let RescriptRelay_Internal = require("rescript-relay/src/RescriptRelay_Internal.bs.js");

let Types = {};

function unwrap_response_renewBuyerNeed(__x) {
  return RescriptRelay_Internal.unwrapUnion(__x, ["BuyerNeedRenewed"]);
}

let variablesConverter = {};

function convertVariables(v) {
  return RescriptRelay.convertObj(v, variablesConverter, undefined, undefined);
}

let wrapResponseConverter = {"__root":{"renewBuyerNeed_BuyerNeedRenewed_buyerNeed":{"f":""},"renewBuyerNeed":{"u":"response_renewBuyerNeed"}}};

let wrapResponseConverterMap = {
  response_renewBuyerNeed: RescriptRelay_Internal.wrapUnion
};

function convertWrapResponse(v) {
  return RescriptRelay.convertObj(v, wrapResponseConverter, wrapResponseConverterMap, null);
}

let responseConverter = {"__root":{"renewBuyerNeed_BuyerNeedRenewed_buyerNeed":{"f":""},"renewBuyerNeed":{"u":"response_renewBuyerNeed"}}};

let responseConverterMap = {
  response_renewBuyerNeed: unwrap_response_renewBuyerNeed
};

function convertResponse(v) {
  return RescriptRelay.convertObj(v, responseConverter, responseConverterMap, undefined);
}

let Internal = {
  variablesConverter: variablesConverter,
  variablesConverterMap: undefined,
  convertVariables: convertVariables,
  wrapResponseConverter: wrapResponseConverter,
  wrapResponseConverterMap: wrapResponseConverterMap,
  convertWrapResponse: convertWrapResponse,
  responseConverter: responseConverter,
  responseConverterMap: responseConverterMap,
  convertResponse: convertResponse,
  convertWrapRawResponse: convertWrapResponse,
  convertRawResponse: convertResponse
};

let Utils = {};

let node = ((function(){
var v0 = [
  {
    "defaultValue": null,
    "kind": "LocalArgument",
    "name": "nodeId"
  }
],
v1 = [
  {
    "fields": [
      {
        "kind": "Variable",
        "name": "nodeId",
        "variableName": "nodeId"
      }
    ],
    "kind": "ObjectValue",
    "name": "input"
  }
],
v2 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "__typename",
  "storageKey": null
},
v3 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "nodeId",
  "storageKey": null
},
v4 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "statusChangeComment",
  "storageKey": null
},
v5 = [
  (v4/*: any*/),
  {
    "alias": null,
    "args": null,
    "kind": "ScalarField",
    "name": "statusChangedAt",
    "storageKey": null
  }
],
v6 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "id",
  "storageKey": null
};
return {
  "fragment": {
    "argumentDefinitions": (v0/*: any*/),
    "kind": "Fragment",
    "metadata": null,
    "name": "RenewBuyerNeedMutation",
    "selections": [
      {
        "alias": null,
        "args": (v1/*: any*/),
        "concreteType": null,
        "kind": "LinkedField",
        "name": "renewBuyerNeed",
        "plural": false,
        "selections": [
          (v2/*: any*/),
          {
            "kind": "InlineFragment",
            "selections": [
              {
                "alias": null,
                "args": null,
                "concreteType": "BuyerNeedV5",
                "kind": "LinkedField",
                "name": "buyerNeed",
                "plural": false,
                "selections": [
                  {
                    "args": null,
                    "kind": "FragmentSpread",
                    "name": "BuyerPageHeader_StatusChangeButton_buyerNeedV5"
                  },
                  {
                    "args": null,
                    "kind": "FragmentSpread",
                    "name": "BuyerPageStatusCallout_buyerNeedV5"
                  },
                  {
                    "args": null,
                    "kind": "FragmentSpread",
                    "name": "ClientPageMatchingStatusLabel_matchable"
                  },
                  {
                    "args": null,
                    "kind": "FragmentSpread",
                    "name": "ChangeBuyerNeedStatus_buyerNeedV5"
                  }
                ],
                "storageKey": null
              }
            ],
            "type": "BuyerNeedRenewed",
            "abstractKey": null
          }
        ],
        "storageKey": null
      }
    ],
    "type": "Mutation",
    "abstractKey": null
  },
  "kind": "Request",
  "operation": {
    "argumentDefinitions": (v0/*: any*/),
    "kind": "Operation",
    "name": "RenewBuyerNeedMutation",
    "selections": [
      {
        "alias": null,
        "args": (v1/*: any*/),
        "concreteType": null,
        "kind": "LinkedField",
        "name": "renewBuyerNeed",
        "plural": false,
        "selections": [
          (v2/*: any*/),
          {
            "kind": "InlineFragment",
            "selections": [
              {
                "alias": null,
                "args": null,
                "concreteType": "BuyerNeedV5",
                "kind": "LinkedField",
                "name": "buyerNeed",
                "plural": false,
                "selections": [
                  (v3/*: any*/),
                  {
                    "alias": null,
                    "args": null,
                    "concreteType": null,
                    "kind": "LinkedField",
                    "name": "status",
                    "plural": false,
                    "selections": [
                      (v2/*: any*/),
                      {
                        "kind": "InlineFragment",
                        "selections": [
                          {
                            "alias": null,
                            "args": null,
                            "kind": "ScalarField",
                            "name": "isRenewable",
                            "storageKey": null
                          },
                          {
                            "alias": null,
                            "args": null,
                            "kind": "ScalarField",
                            "name": "activeUntil",
                            "storageKey": null
                          }
                        ],
                        "type": "ActiveBuyerNeed",
                        "abstractKey": null
                      },
                      {
                        "kind": "InlineFragment",
                        "selections": [
                          {
                            "alias": null,
                            "args": null,
                            "kind": "ScalarField",
                            "name": "expiredAt",
                            "storageKey": null
                          }
                        ],
                        "type": "ExpiredBuyerNeed",
                        "abstractKey": null
                      },
                      {
                        "kind": "InlineFragment",
                        "selections": [
                          {
                            "alias": null,
                            "args": null,
                            "kind": "ScalarField",
                            "name": "withdrawnAt",
                            "storageKey": null
                          },
                          (v4/*: any*/)
                        ],
                        "type": "WithdrawnBuyerNeed",
                        "abstractKey": null
                      },
                      {
                        "kind": "InlineFragment",
                        "selections": (v5/*: any*/),
                        "type": "PurchasedBuyerNeed",
                        "abstractKey": null
                      },
                      {
                        "kind": "InlineFragment",
                        "selections": (v5/*: any*/),
                        "type": "InContractBuyerNeed",
                        "abstractKey": null
                      }
                    ],
                    "storageKey": null
                  },
                  (v6/*: any*/),
                  {
                    "alias": null,
                    "args": null,
                    "concreteType": "ExpiryInfoV5",
                    "kind": "LinkedField",
                    "name": "expiryInfo",
                    "plural": false,
                    "selections": [
                      {
                        "alias": null,
                        "args": null,
                        "kind": "ScalarField",
                        "name": "activePeriodInDays",
                        "storageKey": null
                      }
                    ],
                    "storageKey": null
                  },
                  {
                    "alias": null,
                    "args": null,
                    "concreteType": "Buyer",
                    "kind": "LinkedField",
                    "name": "client",
                    "plural": false,
                    "selections": [
                      {
                        "alias": null,
                        "args": null,
                        "kind": "ScalarField",
                        "name": "displayName",
                        "storageKey": null
                      },
                      (v6/*: any*/),
                      (v3/*: any*/)
                    ],
                    "storageKey": null
                  },
                  {
                    "kind": "InlineFragment",
                    "selections": [
                      (v2/*: any*/),
                      {
                        "alias": null,
                        "args": null,
                        "kind": "ScalarField",
                        "name": "activelyMatching",
                        "storageKey": null
                      }
                    ],
                    "type": "Matchable",
                    "abstractKey": "__isMatchable"
                  }
                ],
                "storageKey": null
              }
            ],
            "type": "BuyerNeedRenewed",
            "abstractKey": null
          }
        ],
        "storageKey": null
      }
    ]
  },
  "params": {
    "cacheID": "b7f972863f6c02363e4a2915100f97a4",
    "id": null,
    "metadata": {},
    "name": "RenewBuyerNeedMutation",
    "operationKind": "mutation",
    "text": "mutation RenewBuyerNeedMutation(\n  $nodeId: ID!\n) {\n  renewBuyerNeed(input: {nodeId: $nodeId}) {\n    __typename\n    ... on BuyerNeedRenewed {\n      buyerNeed {\n        ...BuyerPageHeader_StatusChangeButton_buyerNeedV5\n        ...BuyerPageStatusCallout_buyerNeedV5\n        ...ClientPageMatchingStatusLabel_matchable\n        ...ChangeBuyerNeedStatus_buyerNeedV5\n        nodeId\n      }\n    }\n  }\n}\n\nfragment BuyerPageHeader_StatusChangeButton_buyerNeedV5 on BuyerNeedV5 {\n  nodeId\n  status {\n    __typename\n    ... on ActiveBuyerNeed {\n      isRenewable\n    }\n    ... on ExpiredBuyerNeed {\n      __typename\n    }\n    ... on WithdrawnBuyerNeed {\n      __typename\n    }\n    ... on PurchasedBuyerNeed {\n      __typename\n    }\n    ... on InContractBuyerNeed {\n      __typename\n    }\n  }\n}\n\nfragment BuyerPageStatusCallout_buyerNeedV5 on BuyerNeedV5 {\n  nodeId\n  status {\n    __typename\n    ... on ActiveBuyerNeed {\n      isRenewable\n      ...ExpiringBuyerNeedCallout_activeBuyerNeed\n    }\n    ... on ExpiredBuyerNeed {\n      ...ExpiredBuyerNeedCallout_expiredBuyerNeed\n    }\n    ... on WithdrawnBuyerNeed {\n      ...WithdrawnBuyerNeedCallout_withdrawnBuyerNeed\n    }\n    ... on InContractBuyerNeed {\n      ...InContractBuyerNeedCallout_inContractBuyerNeed\n    }\n    ... on PurchasedBuyerNeed {\n      ...PurchasedBuyerNeedCallout_purchasedBuyerNeed\n    }\n  }\n}\n\nfragment ChangeBuyerNeedStatus_buyerNeedV5 on BuyerNeedV5 {\n  id\n  nodeId\n  status {\n    __typename\n    ... on ActiveBuyerNeed {\n      isRenewable\n      activeUntil\n    }\n    ... on ExpiredBuyerNeed {\n      expiredAt\n    }\n  }\n  expiryInfo {\n    activePeriodInDays\n  }\n  client {\n    displayName\n    id\n    nodeId\n  }\n}\n\nfragment ClientPageMatchingStatusLabel_matchable on Matchable {\n  __isMatchable: __typename\n  __typename\n  activelyMatching\n}\n\nfragment ExpiredBuyerNeedCallout_expiredBuyerNeed on ExpiredBuyerNeed {\n  expiredAt\n}\n\nfragment ExpiringBuyerNeedCallout_activeBuyerNeed on ActiveBuyerNeed {\n  activeUntil\n}\n\nfragment InContractBuyerNeedCallout_inContractBuyerNeed on InContractBuyerNeed {\n  statusChangeComment\n  statusChangedAt\n}\n\nfragment PurchasedBuyerNeedCallout_purchasedBuyerNeed on PurchasedBuyerNeed {\n  statusChangeComment\n  statusChangedAt\n}\n\nfragment WithdrawnBuyerNeedCallout_withdrawnBuyerNeed on WithdrawnBuyerNeed {\n  withdrawnAt\n  statusChangeComment\n}\n"
  }
};
})());

let wrap_response_renewBuyerNeed = RescriptRelay_Internal.wrapUnion;

exports.Types = Types;
exports.unwrap_response_renewBuyerNeed = unwrap_response_renewBuyerNeed;
exports.wrap_response_renewBuyerNeed = wrap_response_renewBuyerNeed;
exports.Internal = Internal;
exports.Utils = Utils;
exports.node = node;
/* node Not a pure module */
